var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_29604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.37563 23.9047C3.15724 23.9047 2.98047 23.7277 2.98047 23.5095V0.590469C2.98047 0.372079 3.15724 0.195312 3.37563 0.195312C3.59401 0.195312 3.77078 0.372079 3.77078 0.590469V23.5095C3.77078 23.7277 3.59375 23.9047 3.37563 23.9047Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5779 21.1888H0.658828C0.440438 21.1888 0.263672 21.0117 0.263672 20.7936C0.263672 20.5755 0.440438 20.3984 0.658828 20.3984H23.5779C23.796 20.3984 23.973 20.5755 23.973 20.7936C23.973 21.0117 23.796 21.1888 23.5779 21.1888Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.65528 14.6544C5.52013 14.6544 5.38841 14.5852 5.31492 14.4606C5.20374 14.2725 5.26592 14.0304 5.45401 13.9192L20.6588 4.92992C20.8475 4.81927 21.0896 4.88092 21.2002 5.06901C21.3114 5.25684 21.2492 5.4992 21.0614 5.61011L5.85602 14.5994C5.79305 14.6365 5.72377 14.6544 5.65528 14.6544Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2014 8.23295C20.169 8.23295 20.1358 8.22874 20.1029 8.22031C19.8913 8.16604 19.7641 7.95081 19.8183 7.73927L20.3789 5.55748L18.1974 4.99689C17.9859 4.94262 17.8586 4.72739 17.9129 4.51585C17.9672 4.30457 18.1821 4.17681 18.3939 4.23134L20.9582 4.89019C21.1698 4.94446 21.297 5.15969 21.2428 5.37123L20.5839 7.93553C20.5381 8.11441 20.3774 8.23295 20.2014 8.23295Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9496 17.8438H5.54125C5.34815 17.8438 5.19141 18.0002 5.19141 18.1936V20.9881H8.29944V18.1936C8.29944 18.0002 8.1427 17.8438 7.9496 17.8438Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4066 15.2422H9.99828C9.80518 15.2422 9.64844 15.3987 9.64844 15.592V20.9909H12.7565V15.5918C12.7565 15.3987 12.6 15.2422 12.4066 15.2422Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8617 12.6406H14.4534C14.2603 12.6406 14.1035 12.7971 14.1035 12.9905V20.994H17.2116V12.9905C17.2113 12.7974 17.0548 12.6406 16.8617 12.6406Z",
    fill: "#2A5578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3187 10.0312H18.9104C18.7173 10.0312 18.5605 10.1877 18.5605 10.3811V20.9889H21.6686V10.3811C21.6686 10.1877 21.5118 10.0312 21.3187 10.0312Z",
    fill: "#2A5578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_29604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.688543d6d7151359643bafe8c37635bd.svg";
export { ForwardRef as ReactComponent };